// A missing or misspelled field used to render the literal string
// "Invalid Date" in the UI. Degrade to an em dash instead — a blank cell is
// obviously missing data, whereas "Invalid Date" reads like a real value and
// hides which field is actually wrong.
const parseDate = (d) => {
  if (d === null || d === undefined || d === '') return null;
  const dt = new Date(d);
  return isNaN(dt.getTime()) ? null : dt;
};

export const fmt = {
  naira: (n) =>
    '₦' + parseFloat(n || 0).toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  date: (d) => {
    const dt = parseDate(d);
    return dt ? dt.toLocaleDateString('en-NG', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
  },
  datetime: (d) => {
    const dt = parseDate(d);
    return dt ? dt.toLocaleString('en-NG', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
  },
  relative: (d) => {
    const dt = parseDate(d);
    if (!dt) return '—';
    const diff = Date.now() - dt.getTime();
    if (diff < 60_000) return 'just now';
    if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
    if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
    return `${Math.floor(diff / 86_400_000)}d ago`;
  },
  bytes: (b) => {
    if (!b) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(b) / Math.log(1024));
    return `${(b / 1024 ** i).toFixed(1)} ${units[i]}`;
  },
};

export const PLANS = [
  { value: '3hr_basic',       label: '3HR Basic',        price: 500 },
  { value: '3hr_fast',        label: '3HR Fast',         price: 700 },
  { value: 'day',             label: '1 Day',            price: 1000 },
  { value: '2day_3gb',        label: '2Day 3GB',         price: 500 },
  { value: '2day_6gb',        label: '2Day 6GB',         price: 800 },
  { value: '7day_12gb',       label: '7Day 12GB',        price: 2000 },
  { value: '7day_unlimited',  label: '7Day Unlimited',   price: 3000 },
  { value: '30day_unlimited', label: '30Day Unlimited',  price: 10000 },
];

export const STATUS_COLOR = {
  active:    { bg: 'var(--green-dim)',  text: 'var(--green)'  },
  success:   { bg: 'var(--green-dim)',  text: 'var(--green)'  },
  expired:   { bg: 'rgba(100,100,120,0.15)', text: 'var(--text2)' },
  cancelled: { bg: 'var(--red-dim)',    text: 'var(--red)'    },
  failed:    { bg: 'var(--red-dim)',    text: 'var(--red)'    },
  pending:   { bg: 'var(--yellow-dim)', text: 'var(--yellow)' },
  inactive:  { bg: 'var(--red-dim)',    text: 'var(--red)'    },
};
